import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) throw new Error("Missing browser-safe Supabase configuration");

// A partially written/stale SDK session must never be allowed to crash app
// startup. Supabase recreates a clean anonymous session after removal.
try {
  const projectRef = new URL(url).hostname.split(".")[0];
  const storageKey = `sb-${projectRef}-auth-token`;
  const raw = localStorage.getItem(storageKey);
  if (raw) {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) localStorage.removeItem(storageKey);
  }
} catch {
  try {
    Object.keys(localStorage).filter((name) => /^sb-.*-auth-token$/.test(name)).forEach((name) => localStorage.removeItem(name));
  } catch {}
}

export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
